export const EXTERNAL_URLS = {
    CRM: "https://crm.zoho.com/crm/",
    Blueprint:
        "https://docs.google.com/document/d/1Y_3HhucUM_CGTaliuzMdH7Am27M6jAhiyqyZwxS3i0A/edit?tab=t.mi0w52awrxus",
};
